import { makeStyles } from 'tss-react/mui';

import { isLightTheme } from 'uiKit/Theme/themeUtils';

const name = 'TopBanner';

export const useTopBannerStyles = makeStyles({ name })(theme => ({
  root: {
    position: 'relative',

    display: 'flex',
    justifyContent: 'center',
    minHeight: 40,
    padding: theme.spacing(3, 10, 4, 4),

    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2.5, 19, 2.5, 2.5),
    },
  },
  text: {
    color: theme.palette.common.white,
    textAlign: 'left',

    '& > span > a': {
      color: theme.palette.common.white,
      textDecoration: 'underline',

      '&:hover': {
        cursor: 'pointer',
      },
    },

    [theme.breakpoints.down('xs')]: {
      fontSize: 12,
    },
  },
  closeIcon: {
    position: 'absolute',
    right: 32,

    color: theme.palette.common.white,

    cursor: 'pointer',

    [theme.breakpoints.down('md')]: {
      top: 12,
      right: 8,
    },
  },
  dark: {
    backgroundColor: isLightTheme(theme)
      ? theme.palette.grey[800]
      : theme.palette.grey[700],
  },
  light: {
    backgroundColor: theme.palette.grey[600],
  },
}));
